<template>
  <div>
    <v-text-field
      v-model="name"
      required
      autofocus
      dense
      class="new-monitoring-point__name"
      :label="$t('field.name_label')"
      :hint="$t('msg.hint_name')"
      :rules="nameRules"
      persistent-hint
      data-testid="new-monitoring-point-name"
    />
    <v-checkbox
      v-model="copyShare"
      :label="$t('field.copy_share_label')"
      class="mt-4 new-monitoring-point__copy-share"
      data-testid="new-monitoring-point-copy-share"
    />
  </div>
</template>

<i18n lang="yaml">
ja:
  field:
    name_label: 'モニタリングポイント名'
    copy_share_label: '共有設定（通知ユーザー）を引き継ぐ'
  msg:
    hint_name: '新しい設置場所に合わせた名前を入力してください'
    name_required: 'モニタリングポイント名を入力してください'
en:
  field:
    name_label: 'Monitoring Point name'
    copy_share_label: 'Copy sharing settings'
  msg:
    hint_name: 'Enter a new name suited for the new location'
    name_required: 'Please enter a Monitoring Point name'
</i18n>

<script>
export default {
  name: 'new-monitoring-point-form',
  inheritAttrs: false,
  data() {
    return {
      name: '',
      copyShare: false,
      nameRules: [
        // 空白だけの入力は valid と同じ基準で弾き、エラー文言と実行ボタンの活性を一致させる
        v => (!!v && v.trim() !== '') || this.$t('msg.name_required'),
      ],
    };
  },
  computed: {
    valid() {
      return this.name.trim() !== '';
    },
  },
  watch: {
    name() {
      this.notifyChange();
    },
    copyShare() {
      this.notifyChange();
    },
  },
  methods: {
    notifyChange() {
      this.$emit('change', { name: this.name, copyShare: this.copyShare, valid: this.valid });
    },
  },
};
</script>

<style scoped lang="sass">
// 入力文字は本文より一段小さくし、ダイアログ内の文字サイズの幅を抑える
.new-monitoring-point
  &__name
    ::v-deep input,
    ::v-deep .v-label
      font-size: 14px

  // 選択系の部品として、移設先の選択肢と同じ寸法に揃える
  &__copy-share
    ::v-deep .v-label
      font-size: 13px

    ::v-deep .v-icon
      font-size: 20px

    ::v-deep .v-input--selection-controls__input
      width: 20px
      height: 20px
      margin-right: 4px
</style>
